import { Container} from "react-bootstrap";
import MainMenu from "../components/main-menu";
import React, {Component} from 'react';
import {Notifications} from "react-push-notification";
import Notification from "../components/notification";
import 'react-modal-video/css/modal-video.css';
import {PATH_APP} from "../routes/paths";
import {Navigate} from "react-router";
import SubmitWeight from "../components/submit-weight";
import WeightChart from "../components/weight-chart";
import axios from "../utils/axios";
import {Link} from "react-router-dom";
import UserState from "../components/user-state";
import {Alert, Backdrop, CircularProgress, Dialog, DialogContent, Skeleton, Slide} from "@mui/material";
import AccountDropdown from "../components/account-dropdown";


const getUser = async () => {
    return await axios.get('/profile');
}
const getRemainedDays = async () => {
    return await axios.post('/get-remained-days');
}
const options = {
    responsive: true,
    plugins: {
        legend: {
            position: 'top',
        },
        title: {
            display: true,
            text: 'Chart.js Line Chart',
        },
    },
};

const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July']

const data = {
    labels,
    datasets: [
        {
            label: 'روز',
            data: labels,
            borderColor: 'rgb(255, 99, 132)',
            backgroundColor: 'rgba(255, 99, 132, 0.5)',
        },
        {
            label: 'وزن',
            data: [1, 2, 3, 4, 5, 6, 7, 8, 9,],
            borderColor: '#37C26F',
            backgroundColor: 'rgba(55,194,111,0.62)',
        },
    ],
}

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            loading: false,
            remainedDays: null,
            user: {
                user_information: {}
            },
            suspend:null,
            loader:false
        };
        this.openModal = this.openModal.bind(this)
    }


    openModal() {
        this.setState({isOpen: true})
    }
    handleCloseLoader () {
        this.setState({
            loader:false
        })
    };

    handleToggleLoader () {
        this.setState({
            loader:!this.state.loader
        })
    };

    componentDidMount() {
        try {
            this.handleToggleLoader()
            this.setState({
                loading: true,
            })
            getRemainedDays().then((response) => {
                this.setState({
                    remainedDays: response.data.message.days,
                })
                if (response.data.status === 401){
                    this.setState({
                        suspend:response.data.message
                    })
                }
                this.handleCloseLoader()
            })
            getUser().then((resposne) => {
                this.setState({
                    user: resposne.data.data,
                    loading: false,
                })
                this.handleCloseLoader()
            });
        } catch (error) {
            console.log(error)
        }
    }


    render() {
        return (
            <div id="home-page">
                <header className="d-flex justify-content-between align-items-center fixed-top gray-header">
                    <h6 className="text-right p-4 mb-0">پروفایل من</h6>
                    <AccountDropdown user={this.state.user}/>
                </header>
                <Notifications/>
                <Notification/>
                <React.Fragment>
                    <Dialog
                        fullWidth
                        open={this.state.isOpen}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={() => this.setState({isOpen: false})}
                    >
                        <DialogContent sx={{p:0}}>
                            <video width="100%" height="100%" controlsList="nodownload" controls style={{display:"flex"}}>
                                <source src="https://app.andamebartar.com/storage/videos/slider.mp4" type="video/mp4"/>
                            </video>
                        </DialogContent>
                    </Dialog>
                </React.Fragment>
                {!this.state.user.user_information && <Navigate to={PATH_APP.verifySuccess}/>}
                <Container style={{marginTop:"74px"}}>
                    {this.state.loading ?
                        <Backdrop
                            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                            open={this.state.loader}
                            onClick={this.handleCloseLoader}
                        >
                            <CircularProgress color="inherit" />
                        </Backdrop> :
                        <>
                            {
                                this.state.suspend !== null ?
                                    <Alert severity="error" className="mb-3" style={{placeContent:"center"}}>{this.state.suspend}</Alert> :""
                            }
                            <img onClick={this.openModal} src={window.location.origin + '/assets/img/slider.png'}
                                 className="mb-3 w-100" alt=""/>
                            <h6 className="text-right pb-1">وضعیت کنونی</h6>
                            <UserState userState={this.state.user}/>
                            <div className="d-flex justify-content-center text-center" id="home-navbar">

                                <div>
                                   <Link to={PATH_APP.courses}>
                                       <img src={window.location.origin + '/assets/svg/courses.svg'} alt=""/>
                                       <h5>دوره آموزشی</h5>
                                   </Link>
                                </div>
                                <div>
                                    <Link to={PATH_APP.chat}>
                                        <img src={window.location.origin + '/assets/svg/tickets.svg'} alt=""/>
                                        <h5>پشتیبانی</h5>
                                    </Link>
                                </div>

                                <div>
                                    <Link to={PATH_APP.dietType}>
                                        <img src={window.location.origin + '/assets/svg/check-list.svg'} alt=""/>
                                        <h5>تمدید برنامه</h5>
                                    </Link>
                                </div>
                            </div>

                            <div className="weight-changes">
                                <h6 className="text-right pb-1">تغییرات وزن</h6>
                                <div className="d-flex justify-content-between bg-white  main-wrapper">
                                    <div className="w-100 item-wrapper">
                                        <div className="d-flex justify-content-between item">
                                            <span>وزن هدف</span>
                                            <span
                                                className="custom-text-blue">{this.state.user?.user_information?.target_weight} کیلوگرم</span>
                                        </div>
                                        <div className="d-flex justify-content-between item">
                                            <span>وزن کنونی</span>
                                            <span
                                                className="custom-text-green">{this.state.user?.user_information?.weight} کیلوگرم</span>
                                        </div>
                                    </div>
                                    <div className="w-100 item-wrapper">
                                        <div className="d-flex justify-content-between item">
                                            <span>قد </span>
                                            <span
                                                className="custom-text-orange">{this.state.user?.user_information?.height} سانتی متر </span>
                                        </div>
                                        <div className="d-flex justify-content-between item">
                                            <span>وزن باقی مانده </span>
                                            <span
                                                className="custom-text-purple">{Math.round(this.state.user?.user_information?.weight) - Math.round(this.state.user?.user_information?.target_weight)} کیلوگرم </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="chart">
                                <WeightChart/>
                                {
                                    this.state.remainedDays != null &&
                                    <SubmitWeight remainedDays={this.state.remainedDays}/>
                                }
                            </div>
                            <h6 className="text-right pb-1">اطلاعات شخصی</h6>
                            <div className="user-info">
                                <ul className="list-unstyled">
                                    <li>
                                        <span>نام شما</span>
                                        <span className="fw-bold">{this.state.user.full_name}</span>
                                    </li>
                                    <li>
                                        <span>جنسیت</span>
                                        <span className="fw-bold">{
                                            this.state.user?.user_information?.gender === 'male' ? 'آقا' : 'خانم'
                                        }</span>
                                    </li>
                                    <li>
                                        <span>وضعیت تاهل</span>
                                        <span className="fw-bold">{
                                            this.state.user?.user_information?.marital_status === 'married' ? 'متاهل' : 'مجرد'
                                        }</span>
                                    </li>
                                    <li>
                                        <span>شماره تلفن</span>
                                        <span className="fw-bold">{this.state.user.mobile}</span>
                                    </li>
                                    <li>
                                        <span>تاریخ ثبت نام</span>
                                        <span className="fw-bold">
                                                {this.state.user.created_at}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </>
                    }
                    <footer className="fixed-bottom">
                        <MainMenu active="home"/>
                    </footer>
                </Container>

            </div>

        );
    }
}


export default Home;
